// Placeholder for entitlement types - will be populated from UI_ARCHITECTURE.md
export enum UserRole {
  YARDMASTER = 'YARDMASTER',
  CONDUCTOR = 'CONDUCTOR',
  PARTNER = 'PARTNER',
  TRANSLOAD_OPERATOR = 'TRANSLOAD_OPERATOR'
}

export enum SeatType {
  DESKTOP = 'DESKTOP',
  HANDHELD = 'HANDHELD',
  PORTAL = 'PORTAL',
  TABLET = 'TABLET'
}

export enum PremiumModule {
  SAFETY_EXPANSION = 'SAFETY_EXPANSION',
  CARBON_REPORTING = 'CARBON_REPORTING',
  TRANSLOAD_AUTOMATION = 'TRANSLOAD_AUTOMATION'
}

export interface FeatureFlags {
  spurDashboard: boolean
  switchListGeneration: boolean
  sweepWorkGeneration: boolean
  blockTrainBuilding: boolean
  inboundManifestReceiver: boolean
  kveSimulationWindows: boolean
  switchListAction: boolean
  trackInventoryCheck: boolean
  adHocTrackOverride: boolean
  mechanicalBadOrderForm: boolean
  blueFlagToggle: boolean
  tagScanningExecution: boolean
  nativeIntentListeners: boolean
  assignedSpurAccess: boolean
  readyToPullMarking: boolean
  partnerDataView: boolean
  foulZoneOverlay: boolean
  carbonReporting: boolean
  carbonDataExport: boolean
  transloadCore: boolean
  transloadAutomation: boolean
  transloadAuditTrail: boolean
}

export interface UserSession {
  userId: string
  email: string
  role: UserRole
  seatType: SeatType
  tenantId: string
  assignedSpurs: string[]
  premiumModules: PremiumModule[]
  featureFlags: FeatureFlags
  entitlementsValidUntil: number
}

export interface EntitlementState {
  session: UserSession | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
  setSession: (session: UserSession) => void
  clearSession: () => void
  refreshEntitlements: () => Promise<void>
  hasFeature: (feature: keyof FeatureFlags) => boolean
  hasModule: (module: PremiumModule) => boolean
  canAccessSpur: (spurId: string) => boolean
}
